import React, {useEffect} from 'react';
import styled from 'styled-components';
import MotifToast from '@ey/motif-react-wrapper/Toast';

export default function Toast(props) {
	const {id, position, className, onClose, variant, duration, children, actions, ...rest} = props;

	useEffect(() => {
		if (duration && onClose) {
			const timer = setTimeout(onClose, duration);
			return () => clearTimeout(timer);
		}
	}, [duration, onClose]);

	return (
		<StyledMotifToast actions={actions} id={id} position={position} variant={variant} className={className} onClose={onClose} {...rest}>
			{children}
		</StyledMotifToast>
	);
}

const StyledMotifToast = styled(MotifToast)``;
